<template>
  <div id="app" class="page-wrapper">
    <!-- @before-enter="customBeforePageEnter"
      @after-enter="customAfterPageEnter"
      @before-leave="customBeforePageLeave"
      @after-leave="customAfterPageLeave" -->
    <transition :name="transitionName">
      <keep-alive include="searchQuestion,allQuestion,smSearch,smDetail">
        <router-view class="page-view" />
      </keep-alive>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      transitionName: 'fade',
      deviceId: "",
      appId: "",
      source: "",
    };
  },
  created() {
    // 监听浏览器后退按钮（包括手势滑动返回）
    window.addEventListener('popstate', this.onPopState);

    // 拦截 router.back / router.go，回退时禁用动画
    const router = this.$router;
    const originalBack = router.back;
    const originalGo = router.go;

    router.back = () => {
      this.transitionName = 'no-animation';
      originalBack.call(router);
    };

    router.go = (n) => {
      this.transitionName = n < 0 ? 'no-animation' : 'fade';
      originalGo.call(router, n);
    };
  },
  watch: {
    $route() {
      // 路由变化后，恢复 fade 动画供下次前进使用
      this.$nextTick(() => {
        this.transitionName = 'fade';
      });
    }
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopState);
  },
  methods: {
    onPopState() {
      this.transitionName = 'no-animation';
    }
  },
};
</script>
<style lang="scss" scoped>
#app {
  min-height: 100vh;
  width: 100vw;
}
$page-change-duration: 0.3s; // 页面转场时间

/* prettier-ignore */
.page-wrapper {
  width: 100%;
  background: #fff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity $page-change-duration ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.no-animation-enter-active,
.no-animation-leave-active {
  transition: none;
}
.no-animation-enter,
.no-animation-leave-to {
  opacity: 1;
}
.page-view {
  position: absolute;
  width: 100%;
  background: white;
  min-height: 100%;
}

</style>
